import { Component, effect, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { LessonFacade } from '@app/store/lesson';
import {
    MaterialListViewComponent,
    MediaVideoComponent,
    MediaAudioComponent,
    MediaImageComponent,
    MediaTextComponent,
    TypeChipComponent,
    UnavailableComponent,
} from '@shared/components';
import { DurationPipe } from '@shared/pipes';
import { DeleteButtonComponent } from './delete-button/delete-button.component';

@Component({
    selector: 'app-lesson-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [
        TranslateModule,
        ButtonModule,
        DurationPipe,
        DeleteButtonComponent,
        MaterialListViewComponent,
        MediaVideoComponent,
        MediaAudioComponent,
        MediaImageComponent,
        MediaTextComponent,
        TypeChipComponent,
        UnavailableComponent,
    ],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly lessonFacade = inject(LessonFacade);

    readonly lesson = this.lessonFacade.lesson;
    readonly loading = this.lessonFacade.loading;
    readonly error = this.lessonFacade.error;
    readonly saving = this.lessonFacade.saving;

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.lessonFacade.getLesson(id);
        }

        // Close on delete success
        effect(() => {
            if (this.lessonFacade.saved()) {
                this.close({ replaceUrl: !this.lessonFacade.lesson() });
            }
        });
    }

    ngOnDestroy(): void {
        this.lessonFacade.clear();
    }

    onEdit(): void {
        const lesson = this.lesson();
        if (lesson) {
            this.router.navigate([{ outlets: { modal: ['lessons', 'edit', lesson.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
